import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Headline from '../common/Headline';
import {
    internationalChallengesData,
    localChallengesData,
} from './challengesData';
import ChallengeCard from './ChallengeCard';
import CustomCarousel from '../custom-carousel/CustomCarousel';
import ParagraphWrapper from '../common/ParagraphWrapper';
import ChallengeModal from './ChallengeModal';

import { useEffect } from 'react';

const Challenges = () => {
    let { challengeId } = useParams();
    const navigate = useNavigate();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalInfo, setModalInfo] = useState({
        img: 'Placeholder Image Source',
        title: 'Placeholder Title',
        subtitle: 'Placeholder Subtitle',
        details: 'Placeholder Details',
        prize: 'Placeholder Prize',
    });

    const showModal = () => {
        var selectedChallenge;

        if (internationalChallengesData.some((el) => el.id === challengeId)) {
            selectedChallenge = internationalChallengesData.find(
                (ele) => ele.id === challengeId
            );
        }

        if (localChallengesData.some((el) => el.id === challengeId)) {
            selectedChallenge = localChallengesData.find(
                (ele) => ele.id === challengeId
            );
        }

        setModalInfo({
            img: selectedChallenge.imgSrc,
            title: selectedChallenge.title,
            subtitle: selectedChallenge.subtitle,
            details: selectedChallenge.modalDetails,
            prize: selectedChallenge.prize,
        });

        setModalIsOpen(true);
    };

    useEffect(() => {
        if (
            challengeId === undefined ||
            internationalChallengesData.some((el) => el.id === challengeId) ||
            localChallengesData.some((el) => el.id === challengeId)
        ) {
            challengeId && showModal();
        }
    }, [challengeId]);

    return (
        <div>
            <ChallengeModal
                open={modalIsOpen}
                setOpen={setModalIsOpen}
                img={modalInfo.img}
                title={modalInfo.title}
                subtitle={modalInfo.subtitle}
                details={modalInfo.details}
                prize={modalInfo.prize}
            />

            <Headline
                headline="International Challenges"
                classNames="text-primary2"
            />
            <div className="mx-auto mb-16">
                <ParagraphWrapper dashedBorderColor={'primary2'}>
                    Collabothon is all about international collaboration, and to
                    spice things up, we present three thrilling international
                    challenges that are available at each of our four event
                    locations. Teams have the freedom to register for any of
                    these challenges, regardless of the location. However, do
                    keep in mind that each challenge will be evaluated
                    separately at its respective location. So, while you can
                    participate in any challenge, your team will be assessed
                    against other teams present at that specific location.
                </ParagraphWrapper>
            </div>
            <div className="flex justify-center items-center mb-16">
                {/* stacked view for bigger screen sizes */}
                <div className="hidden lg:block w-[100%] md:w-[75%]">
                    {internationalChallengesData.map((challenge) => {
                        return (
                            <ChallengeCard
                                key={challenge.id}
                                data={challenge}
                                onClick={() =>
                                    navigate(`/challenges/${challenge.id}`)
                                }
                            />
                        );
                    })}
                </div>
                {/* carousel view for smaller screen sizes */}
                <div className="lg:hidden w-[100%] md:w-[90%]">
                    <CustomCarousel>
                        {internationalChallengesData.map((challenge) => {
                            return (
                                <ChallengeCard
                                    key={challenge.id}
                                    data={challenge}
                                    onClick={() =>
                                        navigate(`/challenges/${challenge.id}`)
                                    }
                                />
                            );
                        })}
                    </CustomCarousel>
                </div>
            </div>
            <Headline
                headline="Local Challenges"
                classNames="text-primary2"
            />
            <div className="mx-auto mb-16">
                <ParagraphWrapper dashedBorderColor={'primary2'}>
                    As we bring Collabothon to different cities, we recognize
                    the value of local ingenuity. That's why we have four
                    fantastic local challenges, specifically crafted for each
                    event location. Teams are encouraged to register and
                    participate in any of these locally-focused challenges, but
                    remember, these opportunities are exclusively available at
                    their corresponding locations. So, make sure to choose
                    wisely based on where you'll be joining us!
                </ParagraphWrapper>
            </div>
            <div className="flex justify-center items-center mb-16">
                <div className="w-[100%] md:w-[75%]">
                    <CustomCarousel>
                        {localChallengesData.map((challenge) => {
                            return (
                                <ChallengeCard
                                    key={challenge.id}
                                    data={challenge}
                                    location={challenge?.location}
                                    onClick={() =>
                                        navigate(`/challenges/${challenge.id}`)
                                    }
                                />
                            );
                        })}
                    </CustomCarousel>
                </div>
            </div>
        </div>
    );
};

export default Challenges;
